import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useParams } from 'react-router-dom';
import leftNav from '../../pages/leftNav';
import './styles.scss';
import config from '../../config';
const LeftNav = (props) => {
    const [isShowMore, setIsShowMore] = useState(false);
    const [menuStyle, setMenuStyle] = useState({
        top: "0px"
    });
    const theData = leftNav.filter(item => {
        return item.id == props.type;
    })[0];

    useEffect(() => {
        
    }, []);

    //const [activeIndex, setActiveIndex] = useState(null);
    const handleDropdown = index => {
        //setActiveIndex(index); 
        setIsShowMore(false);

    };
    const onMouseEnter = index => {

    };
    const onMouseLeave = index => {

    };
    const showMore = () => {
        setIsShowMore(!isShowMore);
    }
    const renderSubmenu = (submenu,index) => {
        return (
            <li key={submenu.id}
                className={`subtitle  ${submenu.namesub ? "hasChild" : ""} ${!submenu.namesub && props.selectId === submenu.id + '' ? "selected" : ""} `}
                onClick={(event) => handleSubmenuClick(event)}
            >
                <NavLink to={config.root + submenu.links} onClick={handleDropdown}>{submenu.sub}</NavLink>
                {
                    submenu.namesub &&
                    submenu.namesub.map((subchild, index) => {
                        return (
                            <div key={subchild.id} className={`subtitle ${props.selectId === subchild.id ? "selected" : ""} `} >
                                <NavLink to={config.root + subchild.links}
                                    onClick={handleDropdown}>{subchild.sub}</NavLink>
                            </div>
                        )
                    })
                }

            </li>
            
            );
    }
    const handleSubmenuClick = (event) => {
        console.log(event.target.offsetTop);
        if (event && event.target) {
            const menuElement = document.getElementById('left-menu');
            if (menuElement) {
                // 计算节点相对于父元素的位置  
                const offsetTop = event.target.offsetTop;
                const scrollTop = 45 * ( parseInt(offsetTop /45)-1);
                //setMenuStyle({ top: -scrollTop});
            }
        }
    };
    return (
            <div id="left-nav">
            <div className="navtitle">
                首页 /
                <Link to={config.root +theData.links} className="subtitle">{theData.name}</Link>
                </div>
            <nav className={`navList ${isShowMore ? 'showMore' : ''}`}>
                <div className="title">{theData.subname}</div>
                <ul id="left-menu" className="leftMenu" style={menuStyle} >
                    {
                        theData.namesub.map(renderSubmenu)
                    }
                </ul>
                <div className="show-more mobile-show" onClick={ showMore}></div>
                </nav>
            </div>
     );
}

export default LeftNav;